"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// prevent ie11 from grey screening
if (typeof window !== 'undefined' && (!window?.console || Object.keys(window?.console).length === 0)) {
  window.console = {
    log() {},
    info() {},
    error() {},
    warn() {}
  };
}
var _default = exports.default = {
  log() {
    if (process.env.NODE_ENV !== 'production') {
      console.log.apply(this, arguments); // eslint-disable-line
    }
  },
  info() {
    if (process.env.NODE_ENV !== 'production') {
      console.info.apply(this, arguments); // eslint-disable-line
    }
  },
  warn() {
    if (process.env.NODE_ENV !== 'production') {
      console.warn.apply(this, arguments); // eslint-disable-line
    }
  },
  error() {
    console.error.apply(this, arguments); // eslint-disable-line
  }
};